import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

import { Placeholder, type PlaceHolderShape } from '@/components/Placeholder';

export function PlaceholderPills({
  title,
  shape,
}: {
  title?: string;
  shape: PlaceHolderShape;
}) {
  return (
    <div className={styles.placeholderContainer}>
      {title && (
        <div
          className={styles.titlePlaceholder}
          style={{ '--pillHeight': '35px' } as React.CSSProperties}
        >
          <Heading variant="sm">{title}</Heading>
        </div>
      )}
      <div className={styles.pillsWrapper}>
        <Placeholder shape={shape} width="110px" height="36px" />
        <Placeholder shape={shape} width="110px" height="36px" />
        <Placeholder shape={shape} width="110px" height="36px" />
      </div>
    </div>
  );
}
